import React from 'react'
import { Table } from 'antd'

export const renderMacroItems = (items) => (
  <Table
    size='small'
    dataSource={items}
    columns={[
      { title: 'Type', dataIndex: 'type', key: 'type' },
      { title: 'Code', dataIndex: 'code', key: 'code' },
      { title: 'Name', dataIndex: 'name', key: 'name' },
      {
        title: 'ICD10',
        dataIndex: 'icd10',
        key: 'icd10',
        render: (text) => text.join(' - ')
      },
      { title: 'QTY', dataIndex: 'qty', key: 'qty' }
    ]}
    pagination={false}
    bordered={true}
  />
)
